import { getItemsFromCollection } from "directus/src/operations";

export async function fetchSurveysClientAverage({ clientId }) {
  try {
    const query = {
      fields: [
        "id",
        "job",
        "job.project.project_id",
        "job.project.name",
        "job.project.client.id",
        "questions.id",
        "questions.question",
        "questions.questions_id.question",
        "questions.question.question",
        "questions.question.category.name",
        "questions.response",
      ],
      filter: {
        job: {
          project: {
            client: {
              id: {
                _eq: clientId,
              },
            },
          },
        },
        status: {
          _eq: "submitted",
        },
      },
    };
    const response = await getItemsFromCollection("surveys", query);

    // Simply return the array of surveys
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

